import React from "react";
import { Link } from "react-router";
import H3 from "~/components/H3";

interface Props {
  title: string,
  description: string,
  link: string,
}

const ToolPlate: React.FC<Props> = (
  {
    title,
    description,
    link,
  }
) => {
  return (
    <div className="px-4 py-5 border border-slate-300 dark:border-slate-600 rounded-md hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors duration-300">
      <H3 className="text-lg sm:text-lg">
        <Link
          className="border-none hover:border-dashed hover:border-accent-600 dark:hover:border-sky-200"
          to={link}
          prefetch="intent"
        >{title}</Link>
      </H3>
      <p className="pt-3 text-sm">{description}</p>
    </div>
  );
};

export default ToolPlate;